import { missingFirebaseEnv } from '../lib/env'
import { Wordmark } from './SignInScreen'

/** Shown instead of a blank page when the Firebase config has not been filled in. */
export function SetupScreen() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 px-8">
      <Wordmark />
      <div className="w-full max-w-sm rounded-xl border border-line bg-surface p-4">
        <p className="text-[14px] font-medium">Firebase config is missing</p>
        <p className="pt-1 text-[13px] leading-relaxed text-faint">
          Copy <code>.env.example</code> to <code>.env.local</code> and fill in these values from the
          Firebase console.
        </p>
        <ul className="pt-3 font-mono text-[12px] leading-relaxed text-dim">
          {missingFirebaseEnv.map((name) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      </div>
    </div>
  )
}
